import Guestlists from '../../../store/guestlists';

angular
    .module('festzelt-os.guestlists')
    .factory('Guestlists', [
        '$injector',
        'Guestlist',
        ($injector, Guestlist) => new Guestlists(Guestlist, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/store/guestlists.js